import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Smooth scroll to top when route changes
    const scrollToTopSmooth = () => {
      const duration = 800; // Animation duration in milliseconds
      const start = window.pageYOffset;
      const startTime = performance.now();

      // Smooth easing function (ease-out cubic)
      const easeOutCubic = (t: number): number => {
        return 1 - Math.pow(1 - t, 3);
      };

      const animateScroll = (currentTime: number) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        // Apply smooth easing function
        const easedProgress = easeOutCubic(progress);
        
        // Calculate current position
        const currentPosition = start - (start * easedProgress);
        
        window.scrollTo(0, currentPosition);
        
        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        }
      };

      requestAnimationFrame(animateScroll);
    };

    // Only scroll if not already at the top
    if (window.pageYOffset > 0) {
      scrollToTopSmooth();
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;